import React from 'react'
import { useLocation } from "react-router-dom";

function LoginFooter(){
    return(
        <footer className="text-[#606060] font-primary p-4 text-center mt-auto border-t-2  border-[#CDD7D9]">
        <p>© 2026 Athlyte. All Rights Reserved.</p>
      </footer>
    )
}

function DefaultFooter(){
    return(
        <footer className="text-[#606060] bg-white px-8 py-4 text-center mt-auto border-t-2  border-[#CDD7D9] flex flex-row justify-between items-center">
            <div className='flex flex-row justify-between items-center gap-2'>
                <img src='/athlyte_logo.png' alt="athlyte logo" className='w-[36px]' />
                <p className='text-xs font-semibold font-primary text-[#292929]'>Athlyte College Sports Communicator</p>
            </div>
           
            <p className='text-xs font-semibold font-primary text-[#606060]'>© 2026 Athlyte. All Rights Reserved. Default</p>
        </footer>
    )
}


function Footer() {
    const location = useLocation();
  return (
    <>
    {location.pathname === "/login" ? <LoginFooter /> : <DefaultFooter />}
    </>
  )
}

export default Footer